<template>
    <div id="homeBox">
        <!--搜索时间头部-->
        <div class="flex mrt5">
            <el-input  style="width: 15%" v-model="defaultValue" clearable size="mini" disabled></el-input>
            <el-select class="mrl2" v-model="gsname" placeholder="请选择公司" @change="changeCompany" size="mini" filterable required  >
                <el-option
                        v-for="item in companyName"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-input class="mrl2" style="width: 15%" v-model="vcName" placeholder="请输入品名或编号" clearable size="mini"></el-input>
            <el-button class="mrl15" icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
            <el-button class="mrl15" type="primary"  :class="baseerp+'btn'" size="mini" @click="updSellInvoice()" :disabled="nextbtn">开票转下月</el-button>
            <el-radio class="mrl15 mrt5"  v-model="radio" label="1" @change="nowmonData">本月</el-radio>
            <el-radio class=" mrt5"  v-model="radio" label="2" @change="nextmonData">已转下月</el-radio>
            <el-button  type="primary"  :class="baseerp+'btn'" size="mini" @click="updSellInvoiceNext()"  :disabled="backbtn">退回上月</el-button>

        </div>
        <!--列表-->
        <el-table
                size="mini"
                ref="deliverlight"
                row-key="vc_xcode"
                class="mrt5"
                :data="tableData"
                style="width: 100%"
                :height="tableHeight"
                :highlight-current-row="highlightCurrentRow"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @selection-change="handleSelectionChange"
        >
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    label="公司名称"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_no"
                    label="库号"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_xcode"
                    label="销售编号"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="f_dfsl"
                    label="数量"
                    width="100"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_khname"
                    label="客户名字"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    label="录入人名字"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_jstime"
                    label="时间"
                    width="100"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kp"
                    label="是否开票"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    fixed="right"
                    label="操作"
                    width="150">
                <template slot-scope="scope">
                    <el-button @click="WatchClick(scope.row)" type="text" size="small">查看</el-button>
                    <el-button type="text" slot="reference" @click="submitData(scope.row)" v-show="scope.row.i_id!=0" :disabled="scope.row.i_state==3||scope.row.i_state==1">审批</el-button>
                    <el-button @click="costClick(scope.row)" type="text" size="small" v-show="scope.row.file_name">费用</el-button>
                </template>
            </el-table-column>-->
        </el-table>
        <!--分页-->
        <div>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="CurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
     <!--
        &lt;!&ndash;查看dialog&ndash;&gt;
        <div :class="baseerp+'div'">
            <el-dialog
                    width="90%"
                    height="800"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <sheet-data :sheet="sheet" @close="cancelDialog" @getStatisticsList="getStatisticsList"></sheet-data>
            </el-dialog>
        </div>
        &lt;!&ndash;费用dialog&ndash;&gt;
        <div :class="baseerp+'div'">
            <el-dialog
                    width="90%"
                    height="800"
                    :title="title"
                    :visible.sync="costdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="costdialogVisible">
                <cost-list :cost="cost" @close="cancelDialog" @getStatisticsList="getStatisticsList"></cost-list>
            </el-dialog>
        </div>
        &lt;!&ndash;审批dialog&ndash;&gt;
        <div :class="baseerp+'div'">
            <el-dialog
                    class="dia"
                    width="30%"
                    :title="title"
                    :visible.sync="checkdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-loading="loading"
                    element-loading-text="正在提交中..."
                    v-if="checkdialogVisible">
                <p>是否提交审批？</p>
                <div style="text-align: right; margin: 0">
                    <el-button size="mini"   @click="checkdialogVisible = false">取消</el-button>
                    <el-button type="primary" :class="baseerp+'btn'" size="mini" :disabled="visible" @click="flowSub()">提交</el-button>
                </div>
            </el-dialog>
        </div>
        -->
    </div>
</template>
<script>
    import axios from 'axios';
    import * as API from "../api"
    import {mapActions} from "vuex";
    //import * as jUtil from '../../utils/spreadJs.js';
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";


    export default {
        name: "InvoiceSale",
        /*components: {SheetData,CostList},*/
        data() {
            return {
                backbtn:true,
                nextbtn:false,
                radio:"1",
                vcName:"",
                multipleSelection:"",
                companyName:[],
                gsid:0,
                gsname:"",

                loading:false,
                mid:0,
                title:"",
                //审批
                checkdialogVisible:false,
                //费用
                costdialogVisible:false,
                //
                i_state:"",
                vcState:[
                    {i_state:0,vc_state:"未提交"},
                    {i_state:3,vc_state:"审核中"},
                    {i_state:1,vc_state:"审核通过"},
                    {i_state:-1,vc_state:"审核不通过"},
                ],
                i_type:"",
                vcType:[
                    {i_type:0,vc_type:"自产"},
                    {i_type:1,vc_type:"代加工"},
                ],
                visible: false,
                //mid:0,
                file_name:"",
                dataTime:"",
                defaultValue:"",
                sheet:{},
                dialogVisible:false,
                pageSize:17,
                currentPage:1,
                tableTotal:0,
                highlightCurrentRow:true,
                tableData:[
                   /* {vc_gsname:"金海威"}*/
                ],
                baseerp: "",
                file_url: "",
                baseApp:"",
                baseVersion:"",
                token:"",
                i_uid:"",
                idData:"",
                idFile:"",
                tableHeight:0,
            }
        },

        computed:{},

        watch:{

            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted() {
            this.baseerp=baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            //console.log('token',this.token,'i_uid',this.i_uid,this.baseApp,this.baseVersion,this.file_url,"123456456")
            //this.getDateMonth();
            this.getCompanyList();
            ////调列表接口
            ///this.getSellInvoiceList();

            this.$nextTick(function () {
                this.onResize();

            });


        },

        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },

            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.deliverlight.$el.clientTop - 220;
            },
            ...mapActions(["getCurrentMenuId"]),

            nextmonData(){
                this.nextbtn=true;
                this.backbtn=false;
                this.getSellInvoiceNextList();
            },

            nowmonData(){
                this.nextbtn=false;
                this.backbtn=true;
                this.getSellInvoiceList();
            },

            //多选
            handleSelectionChange:function(val) {
                this.multipleSelection = val;
               // console.log(val)
            },

            //更新销售开票状态
            async updSellInvoice(){
               // console.log(this.multipleSelection,"multipleSelection");
                if (this.multipleSelection??''!==''){
                    let param={
                        i_mid: this.mid,
                        details:this.multipleSelection,
                        i_gsid:this.gsid,
                        dt_jstime:this.defaultValue,
                    };
                    let res=await API.updSellInvoice(param);
                    if(res.code==1){
                        this.$message.success(res.message);
                        this.$refs.deliverlight.clearSelection();
                        this.getSellInvoiceList();
                    }else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }
                    else{
                        this.$message.error(res.message);
                    }
                }else {
                    this.$message.error("没有选择开票数据！")
                }

            },

            //更新下月销售开票状态
            async updSellInvoiceNext(){
                // console.log(this.multipleSelection,"multipleSelection");
                if (this.multipleSelection??''!==''){
                    let param={
                        i_mid: this.mid,
                        details:this.multipleSelection,
                        i_gsid:this.gsid,
                        dt_jstime:this.defaultValue,
                    };
                    let res=await API.updSellInvoiceNext(param);
                    if(res.code==1){
                        this.$message.success(res.message);
                        this.$refs.deliverlight.clearSelection();
                        this.getSellInvoiceNextList();
                    }else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }
                    else{
                        this.$message.error(res.message);
                    }
                }else {
                    this.$message.error("没有选择开票数据！")
                }

            },

            //公司接口
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid: this.mid,
                    i_type:"1,2,0",
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.companyName=res.data;
                        //this.formData.gsname=this.companyName[0].vc_name;
                        this.gsname=this.companyName[0].vc_name;
                        this.gsid=this.companyName[0].i_id;
                        this.getJsTime();
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            changeCompany(val){
               // console.log("--gsis",val);
                /*if (this.formData.proname??''!==''){
                    this.formData.proname='';
                }*/
                this.gsid=val;
                this.getJsTime();
                //this.getJsTime();
                /*if (val??''!==''){
                    let obj = this.companyName.find(item => item.i_id == val);
                    this.gsname = obj.vc_name;
                }else {
                    this.gsname='';
                }*/
            },

            //获取未结转时间
            async getJsTime(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.gsid,
                };
                let res=await API.getJsTime(param);
                if(res.code==1){
                    this.defaultValue=res.data.dt_jstime;
                   // console.log(this.defaultValue,"this.defaultValue111")
                    this.getSellInvoiceList();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //获取销售开票列表
            async getSellInvoiceList(){

                let param = {
                    i_mid:this.mid,
                    i_gsid:this.gsid,
                    dt_jstime:this.defaultValue,
                    vc_name:this.vcName,
                    page_size:this.currentPage,
                    page_count:17,
                };
                let res = await API.getSellInvoiceList(param);
                if (res.code == 1) {
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    //console.log(res.data,"resssssss")
                    if (res.i_state==1){
                        this.backbtn=true;
                        this.nextbtn=true;
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //获取下月销售开票列表
            async getSellInvoiceNextList(){

                let param = {
                    i_mid:this.mid,
                    i_gsid:this.gsid,
                    dt_jstime:this.defaultValue,
                    vc_name:this.vcName,
                    page_size:this.currentPage,
                    page_count:17,
                };
                let res = await API.getSellInvoiceNextList(param);
                if (res.code == 1) {
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    //console.log(res.data,"resssssss")
                    if (res.i_state==1){
                        this.backbtn=true;
                        this.nextbtn=true;
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            ////

            /*submitData(row){
                this.checkdialogVisible=true;
                this.title="审批";
                //console.log(row,"shenipi")
                this.idData=row.i_id;
                this.idFile=row.fileId;
                this.i_type=row.i_type;
                //console.log( this.idData,this.idFile,"shenpi")

            },*/

            //提交审批接口
            /*async flowSub() {
                //console.log(this.currentPage,"页码");
                this.visible=true;
                this.loading=true;
                let param = {
                    i_mid:this.mid,
                    appid: this.idData,
                    fileid: this.idFile,
                    //flowid: 32,
                    flowid: this.i_type==0?32:(this.i_type==1?33:"")
                };
                // console.log(this.i_type,param,"123");
                let res = await API.flowSub(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.checkdialogVisible=false;
                    this.$message.success(res.message);
                    this.getStatisticsList();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },*/



            //查询
            Search(){
                //console.log(this.i_state,this.i_type,this.defaultValue,"search");
                if (this.radio==1){
                    //console.log("1");
                    this.getSellInvoiceList();
                }else if (this.radio==2){
                    //console.log("2");
                    this.getSellInvoiceNextList();
                }

                ////调列表接口
            },

            //获取当月日期
            getDateMonth(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                //const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.defaultValue=`${date.getFullYear()}-${month}`;
                this.dataTime=`${date.getFullYear()}${month}`;
               // console.log(this.defaultValue,"defaultValue")
            },

            //关闭dialog
            /*cancelDialog(){
                if (this.title=="统计报表"){
                    this.dialogVisible=false;
                    this.highlightCurrentRow=true;
                }else if(this.title=="费用"){
                    this.costdialogVisible=false;
                    this.highlightCurrentRow=true;
                }
            },*/


            //点击费用
            /*costClick(row){
                //console.log(row,"row");
                this.highlightCurrentRow=true;
                this.title="费用";
                this.cost={
                    //taskId:this.taskId,
                    //taskDa:this.taskDa,
                    //page_size:this.currentPage,
                    //timeData:this.defaultValue,
                    //dataTime:this.dataTime,
                    title:"费用",
                    value:row,
                    i_id:row.i_id,
                    i_mid:this.mid,
                };
                console.log(this.cost ,"费用row");
                this.costdialogVisible=true;
            },*/

            //点击查看
            /*WatchClick(row){
                //console.log(row,"row");
                this.highlightCurrentRow=true;
                this.title="统计报表";
                this.sheet={
                    //taskId:this.taskId,
                    //taskDa:this.taskDa,
                    page_size:this.currentPage,
                    timeData:this.defaultValue,
                    dataTime:this.dataTime,
                    title:"统计报表",
                    value:row,
                    i_id:row.i_id,
                    i_mid:this.mid,
                };
                console.log(this.sheet,"查看sheet");
                this.dialogVisible=true;
            },*/

            //分页
            CurrentChange(val){
                // console.log(val,"pageval");
                if (this.radio==1){
                    //console.log("1");
                    this.currentPage=val;
                    this.getSellInvoiceList();
                    ////调列表接口
                }else if (this.radio==2){
                    //console.log("2");
                    this.currentPage=val;
                    this.getSellInvoiceList();
                    ////调列表接口
                }

            },


        },

        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>

    .componentContainer {
        //position: absolute;
        padding: 10px;
        left: 242px;
        top: 0;
        bottom: 20px;
        right: 0;
    }
    .spreadContainer {
        padding: 10px;
        box-shadow: 0 0 20px grey;
    }
    .spreadContainer{
        //position: absolute;
        left: 0px;
        right: 30px;
        top: 100px;
        bottom: 10px;
    }

    .spread-host {
        width: 500px;
        height: 600px;
    }

    .flex{
        justify-content: left;
    }

    .fr{
        float: right;
    }

    .mrt20{
        margin-top: 20px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    .wd{
        width: 150px;
    }

    /deep/{
        .el-dialog__body{
            word-break:unset;
            height: 620px;
            padding: 5px 20px;
        }

        .dia .el-dialog__body{
            word-break:unset;
            height: 100px;
            padding: 5px 20px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 8px;
        }

    }

</style>